module.exports = __webpack_public_path__ + "img/chat-zero-state.f47f06dd.svg";